import {useCallback, useEffect} from 'react';
import {smile} from "./utils/smile";
import {selectUser} from "./helpers";
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {setResize} from "./redux/slices/layoutSlice";
import {resetUser} from "./redux/slices/userSlice";
import {CONSTANTS} from "./constants/constants";
import {
  getUserThunk,
  initializeCountryThunk,
  initializeCurrencyThunk,
  initializeLanguageThunk,
  setCurrencyThunk,
  setLanguageThunk,
} from "./redux/thunks/userThunk";
import {localStorageService} from "./services/localStorageService";

export const useAppInitialization = () => {

  useEffect(() => smile(), []); //smile

  const dispatch = useDispatch();

  const {
    isAuth,
    country,
    currency,
    language,
  } = useSelector(selectUser, shallowEqual);

  const activeModals = useSelector(state => state?.layout.activeModals);

  //modal
  useEffect(() => {
    document.body.style.overflowY = activeModals?.length > 0 ? 'hidden' : 'auto';

    return () => {
      document.body.style.overflowY = 'hidden';
    };
  }, [activeModals]);

  //auth
  //add profile data invalidation *
  useEffect(() => {
    if (isAuth) {
      dispatch(getUserThunk());
    } else {
      dispatch(resetUser());
    }
  }, [isAuth, dispatch]);

  //COUNTRY
  useEffect(() => {
    if (!country) {
      dispatch(initializeCountryThunk());
    }
  }, [dispatch, country]);

  //LANGUAGES
  useEffect(() => {
    if (!!country && !language) {
      const languageTypeSave = localStorageService?.get(CONSTANTS?.VALUE?.LOCAL_STORAGE_KEYS.LANGUAGE) ?? null;
      const languageSave = !!languageTypeSave
        ? Object.values(CONSTANTS?.CONFIG?.LANGUAGES?.AVAILABLE).find((cur) => cur?.TYPE === languageTypeSave)
        : false

      if (languageSave) {
        dispatch(setLanguageThunk({language: languageSave}));
      } else {
        dispatch(initializeLanguageThunk({country}));
      }
    }
  }, [dispatch, country, language]);

  //CURRENCY
  useEffect(() => {
    if (!!country && !currency) {
      const currencyTypeSave = localStorageService?.get(CONSTANTS?.VALUE?.LOCAL_STORAGE_KEYS.CURRENCY) ?? null;
      const currencySave = !!currencyTypeSave
        ? Object.values(CONSTANTS?.CONFIG?.CURRENCY?.AVAILABLE).find((cur) => cur?.TYPE === currencyTypeSave)
        : false

      if (!!currencySave) {
        dispatch(setCurrencyThunk({currency: currencySave}));
      } else {
        dispatch(initializeCurrencyThunk({country}));
      }
    }
  }, [dispatch, currency, country]);

  const handleResize = useCallback(() => {
    const {innerWidth, innerHeight} = window;

    dispatch(setResize({innerWidth, innerHeight}));
  }, [dispatch]);

  //windowWidth
  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [dispatch, handleResize]);
};